var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-cart-offer-bogo"},[_c('div',{staticClass:"c-cart-offer-bogo__offer"},[_c('p',{staticClass:"t-paragraph-small u-center-text"},[_vm._v("\n      "+_vm._s(_vm.message)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }